import "../../sass/child-theme.scss";
// import barba from '@barba/core';
// import gsap from 'gsap';

// barba.init({
//   transitions: [{
//     name: 'opacity-transition',
//     leave(data) {
//       return gsap.to(data.current.container, {
//         opacity: 0
//       });
//     },
//     enter(data) {
//       return gsap.from(data.next.container, {
//         opacity: 0
//       });
//     }
//   }],
//   views: [
//     {
//       namespace: "home",
//       afterEnter(data) {
//         startDVD();
//       },
//       beforeLeave(data) {}
//     },
//     {
//       namespace: "hire",
//       afterEnter(data) {
//         // setUpModal();
//         // registerAllHireSliders();
//         // addHireFormSubmitListener();
//         // setUpFormValidation();
//       },
//     },
//     {
//       namespace: "events",
//       afterEnter(data) {
//         // reloadFilters();
//       },
//     },
//     {
//       namespace: "whats-here",
//       afterEnter(data) {
//         // registerAllSliders();
//       },
//     },
//   ],
// });

// MOBILE MENU
function showMenu() {
  document.querySelector("#navbarNavDropdown").style.display = "block";
  document.querySelector("#close").style.display = "block";
  document.querySelector("#open").style.display = "none";
  document.querySelector("body").style.overflow = "hidden";
  document.querySelector("body").style.position = "fixed";
  document.querySelector("html").style.overflow = "hidden";
  document.querySelector("html").style.position = "fixed";
}
function hideMenu() {
  document.querySelector("#navbarNavDropdown").style.display = "none";
  document.querySelector("#close").style.display = "none";
  document.querySelector("#open").style.display = "block";
  document.querySelector("body").style.overflow = "auto";
  document.querySelector("body").style.position = "relative";
  document.querySelector("html").style.overflow = "auto";
  document.querySelector("html").style.position = "relative";
}

// HIDE SUBMIT BUTTON
function hideSubmit() {
  document.querySelector("#mc-submit").style.opacity = "0";
}

// CONSENT DROP DOWN
function consentDropDown() {
  document.getElementById("hidden-consent").style.opacity = "1";
}

// Menu event listeners
var openMobMenuButton = document.getElementById("open");
var closeMobMenuButton = document.getElementById("close");
openMobMenuButton.addEventListener("click", showMenu);
closeMobMenuButton.addEventListener("click", hideMenu);

// Mailing list signup event listeners
var mailingListInput = document.getElementById("mce-EMAIL");
var mailingListSubmit = document.getElementById("mc-embedded-subscribe");
mailingListInput.addEventListener("input", consentDropDown);
mailingListSubmit.addEventListener("click", hideSubmit);

var colors = [];

const elements = document.querySelectorAll(".floating-link");
elements.forEach((item) => {
  if (item.getAttribute("data-video") != null) {
    colors.push(item.getAttribute("data-video"));
  }
});

var box = document.getElementById("dvd");
var win = window,
  currentColor = Math.floor(Math.random() * colors.length),
  ww = win.innerWidth,
  wh = win.innerHeight,
  translateX = Math.floor(Math.random() * ww),
  translateY = Math.floor(Math.random() * wh),
  boxWidth = box.offsetWidth,
  boxHeight = box.offsetHeight,
  boxTop = box.offsetTop,
  boxLeft = box.offsetLeft,
  xMin = -boxLeft,
  yMin = -boxTop,
  xMax = win.innerWidth - boxLeft - boxWidth,
  yMax = win.innerHeight - boxTop - boxHeight,
  request = null,
  direction = "se",
  speed = 3,
  timeout = null;

if (window.innerWidth < 800) {
  speed = 1.5;
}

var logMarker = "DVD Homepage: ";

function startDVD() {
  var html = document.querySelector("html");

  if (screen.width >= 800 && html.classList.contains("touch"));
  {
    // var box = document.getElementById('dvd'),

    var loaded = false,
      firstRun = true;

    console.log(logMarker + "Initialised with " + colors.length + " videos.");

    init();
    smoothStart();

    // //slow on hover
    // document.getElementById("dvd").addEventListener("mouseover", function(){
    //     speed = 0;
    // });
    // document.getElementById("dvd").addEventListener("mouseout", function(){
    //     speed = 4;
    // });

    // reset constraints on resize
    // window.addEventListener('resize', function(argument) {
    //   clearTimeout(timeout);
    //   timeout = setTimeout(update, 100);
    // }, false);

    function init() {
      setTimeout(() => {
        // clearInterval(timerId);
        // document.getElementById("static").style.zIndex = '-1';
        // document.getElementById("static").style.opacity = '0';
        firstRun = false;
      }, 100);
      document.querySelector("#dvd").style.opacity = "1";
      if (loaded == false) {
        if (firstRun == false && isInViewport(box)) {
          // if ((ww > box.getBoundingClientRect()['left'] ) && (wh > box.getBoundingClientRect()['top'] )) {
          console.log(logMarker + "Visible");
          // firstRun = false
          loaded = true;
          switchColor();
        } else {
          // console.log('off screen!')
        }
      } else {
        // switchColor()
      }
      request = requestAnimationFrame(init);

      move();
    }

    function smoothStart() {
      document.getElementById("static").style.zIndex = "1";
    }

    // reset constraints
    function update() {
      xMin = -boxLeft;
      yMin = -boxTop;
      xMax = win.innerWidth - boxLeft - boxWidth;
      yMax = win.innerHeight - boxTop - boxHeight;
    }

    function move() {
      setDirection();

      setStyle(box, {
        transform: "translate3d(" + translateX + "px, " + translateY + "px, 0)",
      });
    }

    function setDirection() {
      switch (direction) {
        case "ne":
          translateX += speed;
          translateY -= speed;
          break;
        case "nw":
          translateX -= speed;
          translateY -= speed;
          break;
        case "se":
          translateX += speed;
          translateY += speed;
          break;
        case "sw":
          translateX -= speed;
          translateY += speed;
          break;
      }
      setLimits();
    }

    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function setLimits() {
      if (translateY <= yMin) {
        if (direction == "nw") {
          direction = "sw";
        } else if (direction == "ne") {
          direction = "se";
        }
        switchColor();
      }
      if (translateY >= yMax) {
        if (direction == "se") {
          direction = "ne";
        } else if (direction == "sw") {
          direction = "nw";
        }
        switchColor();
      }
      if (translateX <= xMin) {
        if (direction == "nw") {
          direction = "ne";
        } else if (direction == "sw") {
          direction = "se";
        }
        switchColor();
      }
      if (translateX >= xMax) {
        if (direction == "ne") {
          direction = "nw";
        } else if (direction == "se") {
          direction = "sw";
        }
        switchColor();
      }
    }

    function switchColor() {
      if (loaded == true) {
        var color = Math.floor(Math.random() * colors.length);
        while (color == currentColor) {
          color = Math.floor(Math.random() * colors.length);
        }
        document.getElementById("dvd").className = "";
        document.getElementById("dvd").className += colors[color];
        currentColor = color;
        var allVideos = document.querySelectorAll("#dvd video");
        allVideos.forEach((item) => {
          item.pause();
          // item.currentTime = 0;
          item.parentElement.style.zIndex = 0;
        });
        // console.log('All items paused')
        // var currentvid = "." + colors[color] + "-sub-vid"
        // console.log(currentvid)
        // console.log(colors[color])
        var currentVideoPlay = document.querySelector(
          `[data-video="${colors[color]}"] video`,
        );
        // console.log(currentVideoPlay)
        // currentVideoPlay.pause()
        // currentVideoPlay.play()
        // console.log(currentVideoPlay)
        document.querySelector(".tv-static").style.zIndex = 2;
        document.querySelector(".tv-static").style.opacity = 0.8;
        document.querySelector(`[data-video="${colors[color]}"]`).style.zIndex =
          1;

        setTimeout(() => {
          document.querySelector(".tv-static").style.zIndex = 0;
          document.querySelector(".tv-static").style.opacity = 1;
        }, 300);
        currentVideoPlay.play();
        console.log(logMarker + "Video " + colors[color] + " is playing");
      }
    }

    function getVendor() {
      var ua = navigator.userAgent.toLowerCase(),
        match =
          /opera/.exec(ua) ||
          /msie/.exec(ua) ||
          /firefox/.exec(ua) ||
          /(chrome|safari)/.exec(ua) ||
          /trident/.exec(ua),
        vendors = {
          opera: "-o-",
          chrome: "-webkit-",
          safari: "-webkit-",
          firefox: "-moz-",
          trident: "-ms-",
          msie: "-ms-",
        };
      return vendors[match[0]];
    }

    function setStyle(element, properties) {
      var prefix = getVendor(),
        property,
        css = "";
      for (property in properties) {
        css += property + ": " + properties[property] + ";";
        css += prefix + property + ": " + properties[property] + ";";
      }
      element.style.cssText += css;
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector("#dvd")) {
    console.log("starting DVD");
    startDVD();
  }
});

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function updateBoxValues() {
  ((ww = win.innerWidth),
    (wh = win.innerHeight),
    (boxWidth = box.offsetWidth),
    (boxHeight = box.offsetHeight),
    (boxTop = box.offsetTop),
    (boxLeft = box.offsetLeft),
    (xMin = -boxLeft),
    (yMin = -boxTop),
    (xMax = win.innerWidth - boxLeft - boxWidth),
    (yMax = win.innerHeight - boxTop - boxHeight));
  console.log(logMarker + "Viewport resized");
}
const processChange = debounce(() => updateBoxValues());

window.addEventListener("resize", processChange);
